import useAudioStore from '@/Features/Core/store/audioStore';
import useThemeStore from '@/Theme/store';
import { cn } from '@/utils/styles';
import { PauseIcon, PlayIcon } from '@heroicons/react/24/outline';

const MiniAudioPlayer = ({ previewUrl, audioId }) => {
  const { theme } = useThemeStore();
  const { playAudio, pauseAudio, isPlaying } = useAudioStore();

  const handlePlayback = (e) => {
    e.stopPropagation();

    const playing = isPlaying(audioId);

    if (playing) {
      pauseAudio(audioId);
    } else {
      playAudio(audioId, previewUrl);
    }
  };

  return (
    <button
      onClick={handlePlayback}
      className={cn('p-1  rounded-full', {
        'text-black hover:bg-gray-100': theme === 'light',
        'text-white hover:bg-gray-100': theme === 'dark',
      })}
    >
      {isPlaying(audioId) ? (
        <PauseIcon className="size-4" />
      ) : (
        <PlayIcon className="size-4" />
      )}
    </button>
  );
};

export default MiniAudioPlayer;
